<template>
  <div>
    <header
      id="topnav"
      ref="topNavBarHeader"
      class="defaultscroll sticky"
      :class="{ 'bg-white': isWhiteNavbar === true }"
    >
      <div class="container">
        <div>
          <router-link class="logo" to="/" v-if="navLight !== true">
            <img src="@/assets/img/mandaa/logo-dark.png" height="50" alt="" />
          </router-link>
          <router-link class="logo" to="/" v-else>
            <img
              src="@/assets/img/mandaa/logo-dark.png"
              class="l-dark"
              height="50"
              alt=""
            />
            <img
              src="@/assets/img/mandaa/logo-light.png"
              class="l-light"
              height="50"
              alt=""
            />
          </router-link>
        </div>
        <div class="buy-button" v-if="isIcons !== true">
          <base-button
            v-if="authenticatedUser"
            class="btn"
            @click="goToDashboard"
            :class="{
              'btn-light': scrollOnTop === true,
              'btn-primary': scrollOnTop === false,
            }"
          >
            <span data-test="dashboard-mandaa-button"
              ><i class="fas fa-sign-in-alt"></i>
              {{ $t("landing:navbar.dashboard") }}</span
            >
          </base-button>
          <router-link
            v-else
            to="/login"
            class="btn"
            :class="{
              'btn-light': scrollOnTop === true,
              'btn-primary': scrollOnTop === false,
            }"
          >
            <span data-test="login-mandaa-button">{{
              $t("landing:navbar.signin")
            }}</span>
          </router-link>
        </div>
        <div class="menu-extras">
          <div class="menu-item">
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
          </div>
        </div>

        <div id="navigation">
          <ul
            class="navigation-menu"
            :class="{ 'nav-light': navLight === true }"
          >
            <li>
              <a @click="scrollIntoView('home')" class="side-nav-link-ref">{{
                $t("landing:navbar.home")
              }}</a>
            </li>
            <li>
              <a @click="scrollIntoView('prices')" class="side-nav-link-ref">{{
                $t("landing:navbar.prices")
              }}</a>
            </li>
            <li>
              <a
                @click="scrollIntoView('how-works')"
                class="side-nav-link-ref"
                >{{ $t("landing:navbar.how-works") }}</a
              >
            </li>
            <li>
              <router-link to="/contact" class="side-nav-link-ref">
                {{ $t("landing:navbar.contact") }}</router-link
              >
            </li>
          </ul>
          <div class="buy-menu-btn d-none justify-content-center">
            <div class="pr-2">
              <base-button
                v-if="authenticatedUser"
                class="btn"
                @click="goToDashboard"
                :class="{
                  'btn-light': scrollOnTop === true,
                  'btn-primary': scrollOnTop === false,
                }"
              >
                <span data-test="dashboard-mandaa-button-mobile"
                  ><i class="fas fa-sign-in-alt"></i>
                  {{ $t("landing:navbar.dashboard") }}</span
                >
              </base-button>

              <router-link
                v-else
                to="/login"
                class="btn pr-2"
                :class="{
                  'btn-light': scrollOnTop === true,
                  'btn-primary': scrollOnTop === false,
                }"
                ><span data-test="login-mandaa-button-mobile">{{
                  $t("landing:navbar.signin")
                }}</span></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "landing-navbar",
  data() {
    return {
      isCondensed: false,
      scrollOnTop: true,
    };
  },
  props: {
    isWhiteNavbar: {
      type: Boolean,
    },
    navLight: {
      type: Boolean,
    },
    isIcons: {
      type: Boolean,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    const links = document.getElementsByClassName("side-nav-link-ref");
    let matchingMenuItem = null;
    for (let i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      const parent = matchingMenuItem.parentElement;

      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList.add("active");
            }
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters("auth", {
      authenticatedUser: "user",
    }),
  },
  methods: {
    goToDashboard() {
      window.location.href = "/dashboard";
    },
    onScroll(e) {
      const windowTop = e.target.documentElement.scrollTop;
      if (windowTop > 50) {
        this.$refs["topNavBarHeader"]?.classList.add("nav-sticky");
        this.scrollOnTop = false;
      } else {
        this.$refs["topNavBarHeader"]?.classList.remove("nav-sticky");
        this.scrollOnTop = true;
      }

      if (windowTop > 100) {
        document.getElementById("back-to-top").style.display = "inline";
      } else {
        document.getElementById("back-to-top").style.display = "none";
      }
    },
    scrollIntoView(id) {
      if (this.$route.name === "landing") {
        if (id === "home") {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
        document.getElementById(id).scrollIntoView(true);
        return;
      }
      this.$router.push({ name: "landing" }).then(() => {
        document.getElementById(id).scrollIntoView(true);
      });
    },
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },

    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling.nextSibling;

      if (nextEl && !nextEl.classList.contains("open")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("open");
        }
        nextEl.classList.add("open");
      } else if (nextEl) {
        nextEl.classList.remove("open");
      }
      return false;
    },
  },
};
</script>
